import Config from '@config';
import { normalizeInfiniteQueryData } from '@gasbi/shared/common/features/utils';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import { FiltersGrid, Pagination } from '@/features/types';
import { infiniteQueryOptions } from '@/features/utils';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { MeteringDeviceGroups, MeteringDeviceGroupsFilter } from './types';

export const meteringDeviceGroupsApi = createApi({
  reducerPath: 'meteringDeviceGroupsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/metering-device-groups`,
  }),
  tagTypes: ['MeteringDeviceGroups', 'MeteringDeviceGroup'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getMeteringDeviceGroups: builder.query<MeteringDeviceGroups[], void>({
      query: () => ({
        url: '/',
      }),
    }),
    getMeteringDeviceGroupsByNodeId: builder.query<
      MeteringDeviceGroups[],
      MeteringDeviceGroupsFilter
    >({
      query: params => ({
        url: '/query',
        method: 'GET',
        params,
      }),
    }),
    getMeteringDeviceGroupsById: builder.query<MeteringDeviceGroups, string>({
      query: id => ({
        url: `/${id}`,
      }),
    }),
    getMeteringDeviceGroupsI: builder.infiniteQuery<
      MeteringDeviceGroups[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: `/query`,
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['MeteringDeviceGroups'],
    }),
  }),
});

export const {
  useGetMeteringDeviceGroupsQuery,
  useGetMeteringDeviceGroupsByIdQuery,
  useGetMeteringDeviceGroupsByNodeIdQuery,
} = meteringDeviceGroupsApi;

export const useGetMeteringDeviceGroupsIInfiniteQuery =
  normalizeInfiniteQueryData(
    meteringDeviceGroupsApi.useGetMeteringDeviceGroupsIInfiniteQuery,
  );
